
require('./bootstrap');


var Page = function () {

    var tooltips = function () {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        })

    }

    var scrollToTop = function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 50) {
                $('#back-to-top').fadeIn();
            } else {
                $('#back-to-top').fadeOut();
            }
        });
        // scroll body to 0px on click
        $('#back-to-top').click(function () {
            $('#back-to-top').hide();
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });

        $('#back-to-top').show();

    }

    var cardCarousel = function () {

        let cardCarousel = $('#cardCarousel');

        cardCarousel.carousel({
            interval: 10000
        })

        $('#cardCarousel .carousel-item').each(function () {

            var next = $(this).next();
            if (!next.length) {
                next = $(this).siblings(':first');
            }

            next.children(':first-child').clone().appendTo($(this));

            for (var i = 0; i < 1; i++) {
                next = next.next();
                if (!next.length) {
                    next = $(this).siblings(':first');
                }

                next.children(':first-child').clone().appendTo($(this));
            }
        });

    }

    return {
        //main function to initiate the module
        init: function () {
            tooltips();
            scrollToTop();
            cardCarousel();
        }
    };

}();

$(document).ready(function () {
    Page.init();
});

$(window).on('load', function () {
    $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        dots: false,
        autoWidth: true,
        navText: [
            '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            '<i class="fa fa-angle-right" aria-hidden="true"></i>'
        ]
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js